import { render } from "./NotFound.vue?vue&type=template&id=07e9d882&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=07e9d882&lang=less&scoped=true"

import exportComponent from "/Users/yangxinyuan/yxy9022/lit-note/node_modules/.pnpm/vue-loader@17.1.1_vue@3.3.2+webpack@5.82.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e9d882"]])

export default __exports__